import * as React from 'react';
import BOM from "@system/config/bom";
import System from 'src/helper/system';

const BackToBomLink = (props) => {

    const bomId = System.getParams().bomId;
    const { isBomPLP } = props

    return (
        <>
            {
                isBomPLP !== undefined && isBomPLP === 'yes' &&
                <div>
                    <a className="me-3 mt-3 d-block"
                        onClick={() => {
                            window.location.href = BOM.getBomDetailByIdRouteURL(bomId)
                        }}><i className="fa fa-angle-double-left" aria-hidden="true"></i> Back to BOMs</a>
                </div>
            }
        </>
    );
};

export default BackToBomLink;